import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../lib/firebase";

function regionLabel(country) {
  const c = (country || "").toLowerCase().trim();
  if (c === "canada" || c.includes("canada")) return "Province";
  if (c === "ireland" || c.includes("ireland")) return "County";
  if (
    c === "united states" ||
    c === "united states of america" ||
    c === "usa" ||
    c === "us" ||
    c.includes("united states")
  )
    return "State";
  return "Region";
}

export default function ClientCreate() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    organization: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    region: "",
    postalCode: "",
    country: "",
    notes: "",
  });

  async function createClient(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const ref = await addDoc(collection(db, "clients"), {
        createdAt: serverTimestamp(),
        lastUpdatedAt: serverTimestamp(),
        name: form.name.trim() || "Client",
        email: form.email.trim(),
        phone: form.phone.trim(),
        organization: form.organization.trim(),
        addressLine1: form.addressLine1.trim(),
        addressLine2: form.addressLine2.trim(),
        city: form.city.trim(),
        region: form.region.trim(),
        postalCode: form.postalCode.trim(),
        country: form.country.trim(),
        notes: form.notes,
      });

      navigate(`/admin/clients/${ref.id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          alignItems: "flex-start",
        }}
      >
        <div>
          <h2 style={{ marginBottom: 6 }}>New Client</h2>
          <div className="micro muted">Create a client profile</div>
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <Link className="btn" to="/admin/clients">
            Cancel
          </Link>
          <button className="btn primary" type="submit" form="client-create-form" disabled={saving}>
            {saving ? "Saving..." : "Create"}
          </button>
        </div>
      </div>

      <div style={{ marginTop: 16 }}>
        <form id="client-create-form" onSubmit={createClient} className="form">
          <label className="field">
            <input
              type="text"
              placeholder="Client Name"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              required
              disabled={saving}
            />
          </label>

          <div style={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
            <label className="field">
              <input
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                disabled={saving}
              />
            </label>

            <label className="field">
              <input
                type="text"
                placeholder="Phone"
                value={form.phone}
                onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
                disabled={saving}
              />
            </label>
          </div>

          <label className="field">
            <input
              type="text"
              placeholder="Organization (optional)"
              value={form.organization}
              onChange={(e) => setForm((p) => ({ ...p, organization: e.target.value }))}
              disabled={saving}
            />
          </label>

          <label className="field">
            <input
              type="text"
              placeholder="Address line 1"
              value={form.addressLine1}
              onChange={(e) => setForm((p) => ({ ...p, addressLine1: e.target.value }))}
              disabled={saving}
            />
          </label>

          <label className="field">
            <input
              type="text"
              placeholder="Address line 2"
              value={form.addressLine2}
              onChange={(e) => setForm((p) => ({ ...p, addressLine2: e.target.value }))}
              disabled={saving}
            />
          </label>

          <div style={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
            <label className="field">
              <input
                type="text"
                placeholder="City"
                value={form.city}
                onChange={(e) => setForm((p) => ({ ...p, city: e.target.value }))}
                disabled={saving}
              />
            </label>

            <label className="field">
              <input
                type="text"
                placeholder={regionLabel(form.country)}
                value={form.region}
                onChange={(e) => setForm((p) => ({ ...p, region: e.target.value }))}
                disabled={saving}
              />
            </label>
          </div>

          <div style={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
            <label className="field">
              <input
                type="text"
                placeholder="Postal code"
                value={form.postalCode}
                onChange={(e) => setForm((p) => ({ ...p, postalCode: e.target.value }))}
                disabled={saving}
              />
            </label>

            <label className="field">
              <input
                type="text"
                placeholder="Country"
                value={form.country}
                onChange={(e) => setForm((p) => ({ ...p, country: e.target.value }))}
                disabled={saving}
              />
            </label>
          </div>

          <label className="field">
            <textarea
              rows="4"
              placeholder="Client notes"
              value={form.notes}
              onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))}
              disabled={saving}
            />
          </label>
        </form>
      </div>
    </div>
  );
}
